import * as React from 'react';

const SvgIconPlus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" fill="none" width="1em" height="1em" {...props}>
    <path
      d="M1.438 7.375a.625.625 0 1 0 0 1.25v-1.25zm13.124 1.25a.625.625 0 1 0 0-1.25v1.25zM8.625 1.437a.625.625 0 1 0-1.25 0h1.25zm-1.25 13.126a.625.625 0 1 0 1.25 0h-1.25zM1.437 8.625h13.126v-1.25H1.437v1.25zm5.938-7.188v13.126h1.25V1.437h-1.25z"
      fill="currentColor"
    />
  </svg>
);

export default SvgIconPlus;
